import axios from 'axios';
import { useEffect } from 'react';
import { useMutation } from 'react-query';

type VerifyEmailResponse = {
  spaceId: string;
};

export type VerifyEmailProps = {
  verificationCode?: string;
  spaceCode?: string;
  onMutate?: () => void;
};

export const useVerifyEmail = ({
  verificationCode,
  spaceCode,
  onMutate,
}: VerifyEmailProps) => {
  const mutation = useMutation<VerifyEmailResponse, Error, VerifyEmailProps>(
    async (data) => {
      const response = await axios.post<VerifyEmailResponse>(
        'signup/verify/email',
        data
      );
      return response.data;
    },
    {
      onMutate,
    }
  );

  const { mutate } = mutation;

  useEffect(() => {
    if (verificationCode && spaceCode) {
      mutate({ spaceCode, verificationCode });
    }
  }, [verificationCode, spaceCode, mutate]);

  return mutation;
};
